<template>
  <div class="row" id="reports">
    <div class="col-12">
      <v-form @submit.prevent="reset" @keydown="form.onKeydown($event)" ref="form" lazy-validation>
        <v-container grid-list-xl>
          <toolbar
            :title="title"
            :loading="form.busy"
            :buttons="buttons"
            @getBook="getBook"
            @cancel="cancel"
          />
          <v-layout :id="ref" class="wrap justify-space-around form-body">
            <v-col lg="12" md="12" sm="12" cols="12">
              <vuetify-select :states="cat_province_id" />
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <v-menu
                  v-model="form.dateMenu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedDateFormattedStart"
                      label="Fecha de Emisión Inicio"
                      :rules="[rules.required]"
                      required
                      readonly
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-date-picker
                      :color="themeColor"
                      :max="form.dateMax"
                      v-model="form.dateStart"
                      @input="form.dateMenu1 = false"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" style="padding: 0 !important;">
                    <v-btn
                      block
                      :color="themeColor"
                      dark
                      @click="today('one')"
                    >
                      HOY
                    </v-btn>
                  </v-col>
                </v-menu>
            </v-col>
            <v-col lg="4" md="4" sm="4" cols="12">
              <v-menu
                  v-model="form.dateMenu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedDateFormattedEnd"
                      label="Fecha de Emisión Fin"
                      :rules="[rules.required]"
                      required
                      readonly
                      hide-details
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-date-picker
                      :color="themeColor"
                      v-model="form.dateEnd"
                      :max="form.dateMax"
                      @input="form.dateMenu2 = false"
                    />
                  </v-col>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-btn
                      block
                      :color="themeColor"
                      dark
                      @click="today('two')"
                    >
                      HOY
                    </v-btn>
                  </v-col>
                </v-menu>
            </v-col>
          </v-layout>
        </v-container>
      </v-form>
    </div>
    <v-col
      v-if="downloading"
      class="subtitle-1 text-center"
      cols="12"
    > Cargando por favor espere...
    </v-col>
    <v-progress-linear
      indeterminate
      :background-color="backgroundLoadingColor"
      :color="loadingColor"
      height="10"
      v-if="downloading"
    ></v-progress-linear>
    <v-col>
      <div v-if="dateCurrent">
        <p style="font-size: 1.5rem; text-align: center">Quedan</p>
        <flip-countdown :deadline="deadline" :labels="labels"></flip-countdown>
        <p style="font-size: 1.5rem; text-align: center">
          Para generar un nuevo Libro de Ventas
        </p>
      </div>
    </v-col>
  </div>
</template>

<script>
import Form from 'vform';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { format, parseISO } from 'date-fns';
import FlipCountdown from 'vue2-flip-countdown';
import Toolbar from '~/components/Toolbar';
import 'vuetify/src/styles/main.sass';
import VuetifySelect from '~/components/VuetifySelect';

Form.axios = window.axios;
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('generateBook') };
  },
  components: {
    Toolbar,
    VuetifySelect,
    FlipCountdown,
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      loadingColor: 'theme/loadingColor',
      backgroundLoadingColor: 'theme/backgroundLoadingColor',
      themeColor: 'theme/themeColor',
    }),
    ref() {
      return this.form.id;
    },
    deadline() {
      return moment(this.dateCurrent).add(this.daysLimit, 'hours').format('YYYY-MM-DD');
    },
    computedDateFormattedStart() {
        return this.form.dateStart ? moment(this.form.dateStart).format('DD-MM-YYYY') : '';
    },
    computedDateFormattedEnd() {
        return this.form.dateEnd ? format(parseISO(this.form.dateEnd), 'dd-MM-yyyy') : '';
    },
  },
  data: () => ({
    title: 'Generar Libro de Ventas',
    form: new Form({
      busy: false,
      dateStart: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateEnd: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateMax: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
      dateMenu1: false,
      dateMenu2: false,
      enterprise_id: null,
    }),
    buttons: [
      {
        id: 'generate',
        icon: 'mdi-download',
        name: 'Generar Libro de Ventas',
        event: 'getBook',
        color: 'success',
      },
      {
        id: 'cancel',
        icon: 'mdi-close',
        name: 'Cancelar',
        event: 'cancel',
        color: 'red',
      },
    ],
    cat_province_id: '',
    labels: {
      days: 'Días',
      hours: 'Horas',
      minutes: 'Minutos',
      seconds: 'Segundos',
    },
    dateCurrent: '',
    daysLimit: 1,
    disabled: true,
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
    },
    downloading: false,
  }),
  mounted() {
    this.$store.dispatch('taxpayer/setTaxpayerRif', { value: null });
    this.$store.dispatch('taxpayer/setTaxpayerId', { value: null });
    this.form.dateStart = moment(this.dateStart).subtract(7, 'days').format('YYYY-MM-DD');
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        this.valid = true;
      }
    },
   /*  getFecha() {
        const fecha = new Date();
        fecha.setDate(fecha.getDate() - 7);
        return fecha.toISOString().split('T')[0];
    }, */
    /* getSalesBook() {
      const dateRange = moment(this.form.dateEnd).diff(this.form.dateStart, 'month', true);
        if (this.validateContribuyente()) {
          this.validateContribuyente();
          this.downloading = false;
          this.form.busy = false;
      } else if (dateRange > 1) {
          this.$store.dispatch('notifications/show', {
                message: 'El rango de consulta no debe ser mayor a un mes',
                type: 'error',
          });
      } else if (this.form.dateEnd < this.form.dateStart) {
          this.$store.dispatch('notifications/show', {
            message: 'La fecha fin no debe ser menor a la fecha inicio',
            type: 'error',
          });
      } else {
        this.form.enterprise_id = this.$store.state.taxpayer.id;
        window.axios
          .get(`api/salebook/getSaleBook/${this.form.enterprise_id}/${this.form.dateStart}/${this.form.dateEnd}`)
            .then((response) => {
            if (response.data.code === 400) {
              this.$store.dispatch('notifications/show', {
                message: response.data.message,
                type: response.data.type,
              });
              this.form.busy = false;
              this.downloading = false;
              this.dateCurrent = '';
            } else {
              this.disabled = true;
              window.axios.get(`api/salebook/existSaleBook/${this.form.enterprise_id}/${this.form.dateStart}/${this.form.dateEnd}`)
                .then((response) => {
                  if (response.data.code === 400) {
                    this.$store.dispatch('notifications/show', {
                      message: response.data.message,
                      type: response.data.type,
                    });
                    this.form.busy = false;
                    this.downloading = false;
                    this.dateCurrent = '';
                  } else if (response.data.code === 0) {
                    const current = moment(response.data.item.created_at, 'DD-MM-YYYY HH:mm:ss').format('YYYY-MM-DD');
                    const dateNow = moment().format('YYYY-MM-DD');
                    const days = moment(dateNow).diff(current, 'days', true);

                    if (days < this.daysLimit) {
                      this.dateCurrent = current;
                      this.form.busy = false;
                      this.downloading = false;
                    } else {
                      this.dateCurrent = '';
                      this.disabled = false;
                    }
                  } else {
                    this.disabled = false;
                    this.dateCurrent = '';
                  }
                });
            }
          });
      }
    }, */
    getBook() {
      const dateRange = moment(this.form.dateEnd).diff(this.form.dateStart, 'month', true);
      if (dateRange > 1) {
        this.$store.dispatch('notifications/show', {
              message: 'El rango de consulta no debe ser mayor a un mes',
              type: 'error',
        });
      } else if (this.validateContribuyente()) {
          this.validateContribuyente();
          this.downloading = false;
          this.form.busy = false;
      } else if (this.form.dateEnd < this.form.dateStart) {
          this.$store.dispatch('notifications/show', {
            message: 'La fecha fin no debe ser menor a la fecha inicio',
            type: 'error',
          });
      } else {
        this.validate();
        if (this.$refs.form.validate()) {
          this.downloading = true;
          this.form.enterprise_id = this.$store.state.taxpayer.id;
          this.form.busy = true;
          const url = '/api/salebook/generatesalesbook';
        window.axios.post(url, this.form)
        .then((response) => {
          this.form.busy = true;
          this.$router.go(-1);
          this.$store.dispatch('notifications/show', {
            message: response.data.message,
            type: response.data.type,
          });
          this.form.busy = false;
          this.downloading = false;
        })
        .catch(() => {
          this.downloading = false;
          this.form.busy = false;
        });
      }
    }
    },
    validateContribuyente() {
      if (this.$store.state.taxpayer.rif === null) {
          return this.$store.dispatch('notifications/show', {
            message: 'Seleccione el Nº Indentificación del Emisor o Razón Social',
            type: 'error',
          });
      }
    },
    cancel() {
        this.$router.go(-1); // someValue
    },
    today(menu) {
      if (menu === 'one') {
        this.form.dateStart = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.form.dateMenu1 = false;
      } else {
        this.form.dateEnd = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.form.dateMenu2 = false;
      }
    },
  },
};
</script>
<style scoped>
.flip-card {
  font-size: 2rem !important;
}
.flip-clock__slot {
  font-size: 1rem !important;
}
.flip-card__top,
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__back::before,
.flip-card__back::after {
  color: #ffffff !important;
  background: rgba(35, 127, 233, 0.932) !important;
}
</style>
